module.exports = __webpack_public_path__ + "static/media/objects_24.fac11f64.svg";